import React, {Fragment, useEffect, useState} from 'react';
import {WithContext as ReactTags} from 'react-tag-input';
import {tagFront, tag} from '../types/general-types';
import '../sass/tags.scss';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {fetchArticleTagList} from '../reducer/article-reducer';
import {createArticleTag} from '../api/articles';
interface propiedades {
  tags: tagFront[];
  setEtiquetas: (tags: tagFront[]) => void;
  tagOptions: tag[];
  fetchArticleTagList: (token: string) => Promise<any>;
  token: string;
}

interface configObject {
  user: {
    token: string;
  };
  articles: {
    tagList: [];
  };
}

const Etiquetas = (props: propiedades) => {
  const [suggestions, setSuggestions] = useState([
    {
      id: '',
      text: '',
    },
  ]);
  useEffect(() => {
    const call = async () => {
      await props.fetchArticleTagList(props.token);
    };
    if (!props.tagOptions) {
      call();
    }
  }, [props]);

  useEffect(() => {
    if (props.tagOptions) {
      const sugerencias: tagFront[] = [];
      props.tagOptions.forEach((etiqueta) => {
        sugerencias.push({id: etiqueta.id, text: etiqueta.description});
      });
      setSuggestions(sugerencias);
    }
  }, [props.tagOptions]);

  const {tags, setEtiquetas} = props;
  const KeyCodes = {
    comma: 188,
    enter: 13,
  };

  const handleDelete = (i: number) => {
    setEtiquetas(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = async (tag: tagFront) => {
    const ls = props.tagOptions.filter((tagOption) => tagOption.id === tag.id);
    if (ls.length === 0) {
      const res = await createArticleTag(props.token, tag.text.toUpperCase());
      props.fetchArticleTagList(props.token);
      if (typeof res === 'object' && 'data' in res) {
        tag = {id: res.data.id, text: res.data.description};
      }
    }
    setEtiquetas([...tags, tag]);
  };

  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  return (
    <Fragment>
      <p className="mb-3">
        <FormattedMessage id="tags" defaultMessage="tags" />:
      </p>
      <ReactTags
        tags={tags}
        delimiters={delimiters}
        suggestions={suggestions}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        inputFieldPosition="bottom"
        allowDragDrop={false}
        placeholder="Agregá tu etiqueta"
      />
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    tagOptions: state.articles.tagList,
  };
};
export default connect(mapStateToProps, {fetchArticleTagList})(Etiquetas);
